<script setup lang="ts">
import { api } from '@/api';
import Combobox from '@/components/forms/Combobox/Combobox.vue';
import { ref } from 'vue';

defineProps<{
  label?: string;
  errorMessage?: string;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  blur: [event: FocusEvent];
}>();

const modelValue = defineModel<string | null | undefined>();

const units = ref<string[]>([]);
const loading = ref(false);
let loaded = false;

// Loaded on first focus rather than on mount — a task can render many tiles, most of which are
// never edited.
async function loadUnits() {
  if (loaded || loading.value) return;

  loading.value = true;
  const { result, success } = await api.trackItImportApi.getSuggestedUnits();
  loading.value = false;

  if (success) {
    units.value = result ?? [];
    loaded = true;
  }
}
</script>

<template>
  <!-- A combobox rather than a select: units missing from the suggestions stay typeable. -->
  <Combobox
    v-model="modelValue"
    :label="label"
    :items="units"
    :loading="loading"
    :disabled="disabled"
    :errorMessage="errorMessage"
    @focus="loadUnits"
    @blur="(event) => emit('blur', event)"
  />
</template>
